import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRiderVehicleGroups } from '../../services/bookingService';
import { getGroupStatusBadge } from '../../services/multiVehicleService';
import toast from 'react-hot-toast';
import BackButtonBottom from '../../components/common/BackButtonBottom';

export default function VehicleGroupsList() {
  const navigate = useNavigate();
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getRiderVehicleGroups()
      .then((res) => setGroups(res.groups || []))
      .catch((err) => toast.error(err.message || 'Could not load groups'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-[700px] mx-auto p-6">
      <div className="mb-4">
        <button onClick={() => navigate('/rider')} className="bg-transparent border-0 text-brand-primary font-semibold text-[0.9rem] cursor-pointer p-0">← Dashboard</button>
      </div>

      <h1 className="font-serif mt-0 mb-2 text-brand-dark">
        My vehicle groups
      </h1>
      <p className="text-body text-[0.9rem] mb-6">
        Multi-vehicle bookings you've created. Tap a group to see status of each vehicle.
      </p>

      {loading && <div className="p-10 text-center text-muted">Loading...</div>}

      {!loading && groups.length === 0 && (
        <div className="p-10 text-center text-muted bg-white rounded-2xl border border-slate-200">
          You haven't created any multi-vehicle bookings yet.
          <div className="mt-3">
            <button onClick={() => navigate('/rider/book')} className="px-5 py-2.5 rounded-full border-0 bg-brand-primary text-white cursor-pointer font-semibold">Book a trip</button>
          </div>
        </div>
      )}

      <div className="grid gap-3">
        {groups.map((g) => {
          const badge = getGroupStatusBadge(g.status);
          const pickupTime = g.scheduledPickupTime?._seconds
            ? new Date(g.scheduledPickupTime._seconds * 1000)
            : new Date(g.scheduledPickupTime);
          return (
            <div
              key={g.id}
              onClick={() => navigate(`/rider/vehicle-group/${g.id}`)}
              className="p-[18px] rounded-2xl bg-white border border-slate-200 cursor-pointer transition-all"
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#8b5cf6'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.06)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.boxShadow = 'none'; }}
            >
              <div className="flex justify-between items-start mb-1.5">
                <div className="font-bold text-brand-dark text-[1rem]">{g.referenceNumber}</div>
                <span className="px-2.5 py-[3px] rounded-full text-[0.7rem] font-bold" style={{ background: badge.bg, color: badge.color }}>
                  {badge.label}
                </span>
              </div>
              <div className="text-[0.85rem] text-body mb-1">
                {g.vehicleCount} vehicles · {g.totalPassengerCount} passengers
              </div>
              <div className="text-[0.8rem] text-muted mb-1">
                {g.pickupAddress} → {g.destinationAddress}
              </div>
              <div className="text-[0.78rem] text-body">
                {pickupTime.toLocaleString('en-AU', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                {g.totalFare > 0 && <> · ${g.totalFare.toFixed(2)}</>}
              </div>
            </div>
          );
        })}
      </div>
    <BackButtonBottom to="/rider" label="Dashboard" />
    </div>
  );
}